import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDListExternal = {
  namespaced: true,

  state: {
    name: 'dListExternal',
    dListExternal: []
  },

  mutations,
  getters,
  actions
}

export default moduleDListExternal;